import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faCog } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../../AuthContext';
import './SidebarMenuDropdown.css';
import { redirectToLogin } from '../../utils/authRedirect';

const apiUrl = process.env.REACT_APP_API_URL;

const SidebarMenuDropdown = ({ visible, onMenuSelect, selectedMenu }) => {
  const navigate = useNavigate();
  const { setUser } = useAuth();

  const handleLogout = async () => {
    try {
      await fetch(`${apiUrl}/logout`, {
        method: 'POST',
        credentials: 'include',
      });

      localStorage.removeItem('manuallyLoggedOut');
      setUser(null);
      redirectToLogin();
    } catch (err) {
      console.warn('Logout failed:', err);
    }
  };

  if (!visible) return null;
  return (
    <div className="sidebar-dropdown">
      <ul className="sidebar-dropdown-list">
        
        
        <li className={`sidebar-dropdown-item${selectedMenu === 'CoursesInPlace' ? ' active' : ''}`} onClick={() => onMenuSelect && onMenuSelect('CoursesInPlace')}>
          <span className="sidebar-dropdown-icon" role="img" aria-label="Courses"><FontAwesomeIcon icon={faBook} /></span>
          Cursuri
        </li>
        <hr className="sidebar-dropdown-divider" />
        <li className={`sidebar-dropdown-item${selectedMenu === 'Setari' ? ' active' : ''}`} onClick={() => onMenuSelect && onMenuSelect('Setari')}>
          <span className="sidebar-dropdown-icon" role="img" aria-label="Settings"><FontAwesomeIcon icon={faCog} /></span>
          Setari
        </li>
        <li className="sidebar-dropdown-item" onClick={() => navigate('/ajutor')}>Ajutor</li>
        <li className="sidebar-dropdown-item" onClick={handleLogout}>Deconectare</li>
      </ul>
    </div>
  );
};

export default SidebarMenuDropdown;
